var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoticeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_43480",
    "data-name": "Group 43480",
    transform: "translate(1470 -20346)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16118",
    "data-name": "Rectangle 16118",
    width: 32,
    height: 32,
    transform: "translate(-1470 20346)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43480-2",
    "data-name": "Group 43480",
    transform: "translate(-1468 20348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2163",
    d: "M-614.665-307.333a14,14,0,0,1-13.913,14h-.087a14,14,0,0,1-14-14,14,14,0,0,1,14-14h.087A14,14,0,0,1-614.665-307.333Z",
    transform: "translate(642.665 321.333)",
    fill: "#d1131d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_43458",
    "data-name": "Group 43458",
    transform: "translate(12.467 6.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2165",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2167",
    d: "M-70.535-35.272v6.648a1.607,1.607,0,0,1-1.606,1.607h-.043a1.6,1.6,0,0,1-1.093-.47,1.6,1.6,0,0,1-.471-1.136v-6.648a1.607,1.607,0,0,1,1.563-1.606h.043A1.607,1.607,0,0,1-70.535-35.272Z",
    transform: "translate(73.748 36.879)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2169",
    transform: "translate(0.133 12.401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2171",
    d: "M-64.723-32.362A1.474,1.474,0,0,1-66.2-30.888a1.474,1.474,0,0,1-1.474-1.474A1.474,1.474,0,0,1-66.2-33.836,1.474,1.474,0,0,1-64.723-32.362Z",
    transform: "translate(67.672 33.836)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeCircle);
export default __webpack_public_path__ + "static/media/notice-circle.892fbdc4d0143a02789fa8009505c9ba.svg";
export { ForwardRef as ReactComponent };